import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GetReturnType } from '../types/getReturnType';

export interface IUserState {
  userId: number | null;
  anonymousUserId: string | null;
  isAuthenticatedByRedirect: boolean;
  isMarketingAgreement?: boolean;
}

export const userInitialState: IUserState = {
  userId: null,
  anonymousUserId: null,
  isAuthenticatedByRedirect: false,
  isMarketingAgreement: false,
};

// Данные пользователя
export const userSlice = createSlice({
  name: 'user',
  initialState: userInitialState,
  reducers: {
    setMarketingAgreement(state, { payload }: PayloadAction<boolean>) {
      state.isMarketingAgreement = payload;
    },
  },
});

export type TUserSlice = GetReturnType<typeof userSlice.actions>;
export const { setMarketingAgreement } = userSlice.actions;
